import { devShopConfig } from '../Common/DevConfig';
import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { ProductModel } from '../Services/CloudDB/Contract';
import { FirebaseCloudDB } from '../Services/CloudDB/FirebaseCloudDB';

const defaultConfig = {
    livesShop: [],
    goldShop: [],
    bustersShop: {
        needleShop: [],
        brushesShop: [],
        hooksShop: [],
    },
};

@Singleton
export class ShopModel {
    private _config = defaultConfig;
    public canGetLifeFromFriend = true;

    public lifeShopItems: ProductModel[] = devShopConfig().livesShop;

    constructor(
        @Inject private _db: FirebaseCloudDB
    ) {
        this.setConfig(this._db.getShopConfig()); // TODO setup shop data
    }

    setConfig(config) {
        Object.assign(this._config, config);
    }
}
